<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Sort Order Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="sortOrderList"
              :loading="loading"
              :custom-filter="customSearch"
              :no-data-text="noDataText"
              item-key="text"
              v-bind:search="search"
              v-model="selected"
            >
              <template v-slot:item="row">
                <tr :active="row.selected" :key="row.item.text">
                  <td style="width: 50px">
                    <v-checkbox primary hide-details v-model="row.item.sort"></v-checkbox>
                  </td>
                  <td class="text-xs-left">{{ row.item.text }}</td>
                  <td>
                    <v-checkbox primary hide-details v-model="row.item.subTotal"></v-checkbox>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
              Refresh
              <v-icon dark right>mdi-refresh</v-icon></v-btn
            >
            <v-btn color="primary" dark class="mb-2" @click="doSelect">
              Select
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import clone from 'clone'
export default {
  data() {
    return {
      search: '',
      headers: [
        { text: '', value: 'sort', sortable: false },
        { text: 'Sort Order', value: 'text', sortable: false },
        { text: 'Sub Total', value: 'subTotal', sortable: false }
      ],
      sortOrderList: [
        { id: 0, text: 'Billing Account', value: 'BA', subTotal: false, sort: false },
        { id: 1, text: 'Branch', value: 'BR', subTotal: false, sort: false },
        { id: 2, text: 'Business Class', value: 'BC', subTotal: false, sort: false },
        { id: 3, text: 'Business Source', value: 'BS', subTotal: false, sort: false },
        { id: 4, text: 'Class Group', value: 'CG', subTotal: false, sort: false },
        { id: 5, text: 'Client Status', value: 'CS', subTotal: false, sort: false },
        { id: 6, text: 'Client Type', value: 'CT', subTotal: false, sort: false },
        { id: 7, text: 'Country', value: 'CO', subTotal: false, sort: false },
        { id: 8, text: 'Direct/RI', value: 'DR', subTotal: false },
        { id: 9, text: 'Executive In-charge', value: 'EX', subTotal: false, sort: false },
        { id: 10, text: 'Fund', value: 'FD', subTotal: false, sort: false },
        { id: 11, text: 'Intermediary Type', value: 'IT', subTotal: false, sort: false },
        { id: 12, text: 'Policy Type', value: 'PT', subTotal: false, sort: false },
        { id: 13, text: 'Underwriting Year', value: 'UY', subTotal: false, sort: false }
      ],
      selected: [
        {
          subTotal: [],
          sort: []
        }
      ],
      errMsgLen: 'Allows up to 6 selections',
      errMsgSel: 'Please select the Sort Order(s) before select the Sub Total(s)',
      origArr: []
    }
  },
  created() {
    this.origArr = clone(this.sort)
    this.doInit()
  },
  methods: {
    doInit() {
      if (this.selectedSortOrderList.length !== 0) {
        this.selectedSortOrderList.map((sort) => {
          const index = sort.id
          this.sortOrderList[index] = sort
          this.selected.push(sort)
        })
      }
    },
    doSelect() {
      const selectedItems = []
      const sort = this.sortOrderList
      const resultBoth = sort.filter((sort) => sort.subTotal === true && sort.sort === true)
      const resultSubTotal = sort.filter((sort) => sort.subTotal === true && sort.sort === false)
      const resultSortOrder = sort.filter((sort) => sort.subTotal === false && sort.sort === true)
      const bothLength = resultBoth.length * 2
      const stLength = resultSubTotal.length
      const pbLength = resultSortOrder.length
      if (resultBoth.length + stLength + pbLength > 6) {
        this.$toast.error(this.errMsgLen)
      } else if (stLength > 0) {
        this.$toast.error(this.errMsgSel)
      } else {
        if (bothLength !== 0) {
          for (var iBoth = 0; iBoth < resultBoth.length; iBoth++) {
            selectedItems.push(resultBoth[iBoth])
          }
        }
        if (stLength !== 0) {
          for (var iSt = 0; iSt < stLength; iSt++) {
            selectedItems.push(resultSubTotal[iSt])
          }
        }
        if (pbLength !== 0) {
          for (var iPb = 0; iPb < pbLength; iPb++) {
            selectedItems.push(resultSortOrder[iPb])
          }
        }
        const pageHeaderObj = {
          sort: selectedItems,
          from: 'sort'
        }
        this.$emit('doAssign', pageHeaderObj)
        this.$emit('close')
      }
    },
    doCancel() {
      const pageHeaderObj = {
        sort: this.origArr,
        from: 'sort'
      }
      this.$emit('doAssign', pageHeaderObj)
      this.$emit('close')
    },
    doReset() {
      for (let i in this.sortOrderList) {
        this.sortOrderList[i].sort = false
        this.sortOrderList[i].subTotal = false
      }
    }
  },
  computed: {
    selectedSortOrderList() {
      return this.sort
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: {
    sort: Array
  }
}
</script>
